import { ISalonDetailsApi } from '@app/salon-details/models/salon-details-api.model';
import { ITreatmentCategory } from '@app/salon-details/models/treatment-category.model';
import { ISalonReviews } from '@app/shared/models/salon-reviews.model';

export interface ISalonPage {
  salonDetails: ISalonDetailsApi;
  treatmentCategories: ITreatmentCategory[];
  salonReviews?: ISalonReviews;
}
